import Login from "./views/Login";
import Home from "./views/Home";
import HomeGerente from "./views/HomeGerente";
import Register from "./views/Register";
import ForgotPassword from "./views/ForgotPassword";

import ProfileEmpresa from "./views/screensEmpresa/Profile";
import Instituicao from "./views/screensEmpresa/Instituicao";
import AlunosEmpresa from "./views/screensEmpresa/Alunos";
import UsuariosEmpresa from "./views/screensEmpresa/UsuariosEmpresa";
import UserType from "./views/screensEmpresa/UserType";
import TipoTerceiro from "./views/screensEmpresa/TipoTerceiro";
import Terceiro from "./views/screensEmpresa/Terceiro";
import Contrato from "./views/screensEmpresa/Contrato";
import Curso from "./views/screensEmpresa/Curso";
import Vendedor from "./views/screensEmpresa/Vendedor";
import TipoCusto from "./views/screensEmpresa/TipoCusto";
import Agenda from "./views/screensEmpresa/Agenda";
import TipoAgenda from "./views/screensEmpresa/TipoAgenda";
import PreparacaoAlbum from "./views/screensEmpresa/PreparacaoAlbum";
import CategoriaFinanceira from "./views/screensEmpresa/CategoriaFinanceira";
import ContaFinanceira from "./views/screensEmpresa/ContaFinanceira";
import FluxoCaixa from "./views/screensEmpresa/FluxoCaixa";
import ContaPagar from "./views/screensEmpresa/ContaPagar";
import ContaPaga from "./views/screensEmpresa/ContaPaga";
import ContaReceber from "./views/screensEmpresa/ContaReceber";
import FormaPagamento from "./views/screensEmpresa/FormaPagamento";
import Produto from "./views/screensEmpresa/Produto";
import Despesas from "./views/screensEmpresa/DespesasVendedor";
import ProfileInstituicao from "./views/screensInstituicao/Profile";
import AlunosInstituicao from "./views/screensInstituicao/Alunos";
import TipoDespesasVendedor from "./views/screensEmpresa/TipoDespesasVendedor";
import ContaProvisionada from "./views/screensEmpresa/ContaProvisionada";
import TipoContaPagar from "./views/screensEmpresa/TipoContaPagar";
import DespesasFotografo from "./views/screensGerente/DespesasFotografo";
import TipoServico from "./views/screensEmpresa/TipoServico";

import ProfileAluno from "./views/screensAluno/Profile";
import RelatorioVenda from "./views/screensEmpresa/RelatorioVenda";
import AlunoDetalhado from "./views/screensEmpresa/AlunoDetalhado";
import AgendaGerente from "./views/screensGerente/AgendaGerente";

export const routes = [
  {
    path: "/index",
    name: "Página Inicial",
    icon: "fa fa-home text-yellow",
    component: <Home />,  
    layout: "/admin",
  },
  {
    path: "/register",
    name: "Cadastrar Escritório",
    icon: "fa-solid fa-building text-orange",
    component: <Register />,
    layout: "/auth",
  },
  {
    path: "/login",
    name: "Sair",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/forgot-password",
    name: "Esqueceu a Senha",
    icon: "ni ni-lock-circle-open text-info",
    component: <ForgotPassword />,
    layout: "/auth",
  },
];

export const routesEmpresa = [
  {
    type: "route",
    name: "Painel Empresa",
    key: "painel_empresa",
    icon: "fa fa-home text-gray",
    subMenu: [
      {
        type: "route",
        name: "Dashboard",
        key: "dashboard_empresa",
        path: "/index",
        layout: "/admin",
        icon: "fa fa-home text-gray",
        component: <Home />,
      },
      {
        type: "route",
        name: "Meu Perfil",
        key: "perfil_empresa",
        path: "/profile",
        layout: "/admin",
        icon: "fa-regular fa-address-card text-gray",
        component: <ProfileEmpresa />,
      },
    ],
  },
  {
    type: "route",
    name: "Usuários & Permissões",
    key: "usuarios_permissoes",
    icon: "fa-solid fa-user-shield text-gray",
    subMenu: [
      {
        type: "route",
        name: "Outros Usuários",
        key: "usuarios_empresa",
        path: "/usuariosEmpresa",
        layout: "/admin",
        icon: "fa-solid fa-user-plus text-gray",
        component: <UsuariosEmpresa />,
      },
      {
        type: "route",
        name: "Tipos de Usuários",
        key: "tipos_usuarios",
        path: "/userType",
        layout: "/admin",
        icon: "fa-solid fa-user-plus text-blue",
        component: <UserType />,
      },
    ],
  },
  {
    type: "route",
    name: "Instituições & Alunos",
    key: "instituicoes_alunos",
    icon: "fa-solid fa-city text-gray",
    subMenu: [
      {
        type: "route",
        name: "Instituições",
        key: "instituicao",
        path: "/instituicao",
        layout: "/admin",
        icon: "fa-solid fa-city text-gray",
        component: <Instituicao />,
      },
      {
        type: "route",
        name: "Cursos",
        key: "curso",
        path: "/curso",
        layout: "/admin",
        icon: "fa-solid fa-users text-gray",
        component: <Curso />,
      },
    ],
  },
  {
    type: "route",
    name: "Agenda",
    key: "agenda",
    icon: "fa-regular fa-calendar text-gray",
    subMenu: [
      {
        type: "route",
        name: "Gerenciar Agenda",
        key: "gerenciar_agenda",
        path: "/agenda",
        layout: "/admin",
        icon: "fa-regular fa-calendar text-gray",
        component: <Agenda />,
      },
      {
        type: "route",
        name: "Tipos de Agenda",
        key: "tipos_agenda",
        path: "/tipoAgenda",
        layout: "/admin",
        icon: "fa-regular fa-calendar text-blue",
        component: <TipoAgenda />,
      },
    ],
  },
  {
    type: "route",
    name: "Terceiros",
    key: "terceiros",
    icon: "fa-solid fa-people-arrows text-gray",
    subMenu: [
      {
        type: "route",
        name: "Gerenciar Terceiros",
        key: "gerenciar_terceiros",
        path: "/terceiros",
        layout: "/admin",
        icon: "fa-solid fa-people-arrows text-gray",
        component: <Terceiro />,
      },
      {
        type: "route",
        name: "Tipos de Terceiros",
        key: "tipos_terceiros",
        path: "/tipoTerceiro",
        layout: "/admin",
        icon: "fa-solid fa-people-arrows text-blue",
        component: <TipoTerceiro />,
      },
      {
        type: "route",
        name: "Serviços",
        key: "servicos",
        path: "/servicos",
        layout: "/admin",
        icon: "fa-solid fa-people-arrows text-blue",
        component: <TipoServico />,
      },
    ],
  },
  {
    type: "route",
    name: "Custos",
    key: "custos",
    icon: "fa-solid fa-money-bill text-gray",
    subMenu: [
      {
        type: "route",
        name: "Tipos de Custos",
        key: "tipos_custos",
        path: "/tipoCusto",
        layout: "/admin",
        icon: "fa-solid fa-money-bill text-gray",
        component: <TipoCusto />,
      },
    ],
  },
  {
    type: "route",
    name: "Contratos & Álbuns",
    key: "contratos_albuns",
    icon: "fa-solid fa-file-lines text-gray",
    subMenu: [
      {
        type: "route",
        name: "Contratos",
        key: "contrato",
        path: "/contrato",
        layout: "/admin",
        icon: "fa-solid fa-file-lines text-gray",
        component: <Contrato />,
      },
      {
        type: "route",
        name: "Preparação de Álbuns",
        key: "preparacao_album",
        path: "/preparacaoAlbum",
        layout: "/admin",
        icon: "fa-solid fa-book text-gray",
        component: <PreparacaoAlbum />,
      },
    ],
  },
  {
    type: "route",
    name: "Movimentação",
    key: "movimentacao",
    icon: "fa-solid fa-chart-line text-gray",
    subMenu: [
      {
        type: "route",
        name: "Relatório de vendas",
        key: "relatorio_vendas",
        path: "/relatorioVendas",
        layout: "/admin",
        icon: "fa-solid fa-chart-line text-gray",
        component: <RelatorioVenda />,
      },
      {
        type: "route",
        name: "Aluno Detalhado",
        key: "alunoDetalhado",
        path: "/alunoDetalhado",
        layout: "/admin",
        icon: "fa-solid fa-city text-gray",
        component: <AlunoDetalhado />,
      },
    ],
  },
  {
    type: "route",
    name: "Financeiro",
    key: "financeiro",
    icon: "fa-solid fa-wallet text-gray",
    subMenu: [
      {
        type: "route",
        name: "Categorias Financeiras",
        key: "categoria_financeira",
        path: "/categoriaFinanceira",
        layout: "/admin",
        icon: "fa-solid fa-layer-group text-gray",
        component: <CategoriaFinanceira />,
      },
      {
        type: "route",
        name: "Tipo de Conta a Pagar",
        key: "tipo_conta_pagar",
        path: "/tipoContaPagar",
        layout: "/admin",
        icon: "fa-solid fa-layer-group text-gray",
        component: <TipoContaPagar />,
      },
      {
        type: "route",
        name: "Contas Financeiras",
        key: "conta_financeira",
        path: "/contaFinanceira",
        layout: "/admin",
        icon: "fa-solid fa-wallet text-blue",
        component: <ContaFinanceira />,
      },
      {
        type: "route",
        name: "Formas de Pagamento",
        key: "forma_pagamento",
        path: "/formaPagamento",
        layout: "/admin",
        icon: "fa-solid fa-wallet text-blue",
        component: <FormaPagamento />,
      },
      // {
      //   type: "route",
      //   name: "Fluxo de Caixa",
      //   key: "fluxo_caixa",
      //   path: "/fluxoCaixa",
      //   layout: "/admin",
      //   icon: "fa-solid fa-money-bill text-blue",
      //   component: <FluxoCaixa />,
      // },
      {
        type: "route",
        name: "Contas a Pagar",
        key: "conta_pagar",
        path: "/contaPagar",
        layout: "/admin",
        icon: "fa-solid fa-file-invoice-dollar text-blue",
        component: <ContaPagar />,
      },
      {
        type: "route",
        name: "Contas Pagas",
        key: "conta_pagas",
        path: "/contaPagas",
        layout: "/admin",
        icon: "fa-solid fa-file-invoice-dollar text-blue",
        component: <ContaPaga />,
      },
      {
        type: "route",
        name: "Contas a Receber",
        key: "conta_receber",
        path: "/contaReceber",
        layout: "/admin",
        icon: "fa-solid fa-file-invoice-dollar text-blue",
        component: <ContaReceber />,
      },
      {
        type: "route",
        name: "Contas Provisionadas",
        key: "conta_provisionada",
        path: "/contaProvisionada",
        layout: "/admin",
        icon: "fa-solid fa-file-invoice-dollar text-blue",
        component: <ContaProvisionada />,
      },
    ],
  },
  {
    type: "route",
    name: "Produtos",
    key: "produtos",
    icon: "fa-solid fa-boxes-stacked text-gray",
    subMenu: [
      {
        type: "route",
        name: "Produtos",
        key: "produtos",
        path: "/produtos",
        layout: "/admin",
        icon: "fa-solid fa-boxes-stacked text-gray",
        component: <Produto />,
      },
    ],
  },
  {
    type: "route",
    name: "Despesas",
    key: "despesas",
    icon: "fa-solid fa-cart-plus text-gray",
    subMenu: [
      {
        type: "route",
        name: "Tipos de despesas",
        key: "tipoDespesas",
        path: "/tipoDespesas",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-gray",
        component: <TipoDespesasVendedor />,
      },
      {
        type: "route",
        name: "Despesas",
        key: "despesas",
        path: "/despesas",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-gray",
        component: <Despesas />,
      },
    ],
  },
  {
    type: "route",
    name: "Sair",
    key: "sair",
    path: "/login",
    layout: "/auth",
    icon: "ni ni-key-25 text-gray",
    component: <Login />,
  },
];

export const routesGerenteFotografo = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "fa fa-home text-gray",
    component: <HomeGerente />,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "Meu Perfil",
    icon: "fa-regular fa-address-card text-gray",
    component: <ProfileEmpresa />,
    layout: "/admin",
  },
  {
    type: "route",
    name: "Agenda",
    key: "agenda",
    icon: "fa-regular fa-calendar text-gray",
    subMenu: [
      {
        type: "route",
        name: "Gerenciar Agenda",
        key: "gerenciar_agenda",
        path: "/agenda",
        layout: "/admin",
        icon: "fa-regular fa-calendar text-gray",
        component: <AgendaGerente />,
      }
    ],
  },
  {
    type: "route",
    name: "Despesas",
    key: "despesas",
    icon: "fa-solid fa-cart-plus text-gray",
    subMenu: [
      {
        type: "route",
        name: "Despesas Fotografo",
        key: "despesasFotografo",
        path: "/despesasFotografo",
        layout: "/admin",
        icon: "fa-solid fa-cart-plus text-gray",
        component: <DespesasFotografo />,
      },
    ],
  },
  {
    path: "/login",
    name: "Sair",
    icon: "ni ni-key-25 text-gray",
    component: <Login />,
    layout: "/auth",
  },
];

export const routesInstituicao = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "fa fa-home text-gray",
    component: <Home />,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "Meu Perfil",
    icon: "fa-regular fa-address-card text-gray",
    component: <ProfileInstituicao />,
    layout: "/admin",
  },
  {
    path: "/aluno",
    name: "Gerenciamento de alunos",
    icon: "fa-solid fa-user text-gray",
    component: <AlunosInstituicao />,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Sair",
    icon: "ni ni-key-25 text-gray",
    component: <Login />,
    layout: "/auth",
  },
];

export const routesAluno = [
  {
    path: "/index",
    name: "Página Inicial",
    icon: "fa fa-home text-gray",
    component: <Home />,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "Meu Perfil",
    icon: "fa-regular fa-address-card text-gray",
    component: <ProfileAluno />,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Sair",
    icon: "ni ni-key-25 text-gray",
    component: <Login />,
    layout: "/auth",
  },
];

export const routesAdmin = [
  {
    path: "/login",
    name: "Sair",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
];
